import { virtualPosEnum, presentialPosEnum } from "../enums";

export default (function (_ref, inject) {
  var store = _ref.store,
      app = _ref.app;

  inject("controlMessage", function (error) {
    return store.dispatch("controlMessage", error);
  });
  inject("isAdmin", function () {
    return store.getters["user/isAdmin"];
  });
  inject("isAdminCollaborator", function () {
    return store.getters["user/isAdminCollaborator"];
  });
  inject("isTariffManager", function () {
    return store.getters["user/isTariffManager"];
  });
  inject("isBoss", function () {
    return store.getters["user/isBoss"];
  });
  inject("isSeller", function () {
    return store.getters["user/isSeller"];
  });
  inject("isSupervisor", function () {
    return store.getters["user/isSupervisor"];
  });

  inject("isVirtual", function () {
    return store.getters["affiliations/form/isVirtual"];
  });
  inject("isPresential", function () {
    return store.state.affiliations.form.productType === "1";
  });
  inject("posSelected", function () {
    return store.state.affiliations.form.posSelected.pos;
  });

  // inject('isPagoWeb', () => store.state.affiliations.form.posSelected.pos == app.$virtualPosEnum.PAGO_WEB)
  inject("isPagoWeb", function () {
    return store.getters["affiliations/form/isPagoWeb"];
  });
  inject("isPagoApp", function () {
    return store.state.affiliations.form.posSelected.pos == app.$virtualPosEnum.PAGO_APP;
  });
  inject("isPagoLink", function () {
    return store.state.affiliations.form.posSelected.pos == app.$virtualPosEnum.PAGO_LINK;
  });

  inject("isPosFijoInternet", function () {
    return store.state.affiliations.form.posSelected.pos == "POS fijo Internet";
  });
  inject("isPosInalambrico", function () {
    return store.state.affiliations.form.posSelected.pos == "POS Inalámbrico";
  });
  inject("isCorresponsalia", function () {
    return store.state.affiliations.form.posSelected.pos == "Corresponsalía";
  });
  inject("virtualPosEnum", virtualPosEnum);
  inject("presentialPosEnum", presentialPosEnum);
  inject("toCapitalize", function (str) {
    if (str.trim().length < 0) return "";
    if (str.trim().length == 1) return str.trim().charAt(0).toUpperCase();
    return str.trim().toLowerCase().replace(/\b\w/g, function (l) {
      return l.toUpperCase();
    });
  });
});


//////////////////
// WEBPACK FOOTER
// ./src/plugins/store.js
// module id = ./src/plugins/store.js
// module chunks = 34